/**
 * Serviço de Dashboard
 * Funções para buscar métricas e dados consolidados
 */

import api from './api';

/**
 * Busca métricas do dashboard (DNZ, DARF, DAS, etc)
 */
export const getMetricas = async (mes, ano) => {
  const params = {};
  if (mes) params.mes = mes;
  if (ano) params.ano = ano;
  
  const response = await api.get('dashboard/metricas', { params });
  return response;
};

/**
 * Busca dados para gráfico de fluxo mensal
 */
export const getFluxoMensal = async () => {
  const response = await api.get('dashboard/fluxo-mensal');
  return response;
};

/**
 * Busca despesas por categoria
 */
export const getDespesasPorCategoria = async (mes, ano) => {
  const params = {};
  if (mes) params.mes = mes;
  if (ano) params.ano = ano;
  
  const response = await api.get('dashboard/despesas-categoria', { params });
  return response;
};

/**
 * Calcula Lucro Presumido
 */
export const calcularLucroPresumido = async (mes, ano, receitaMensal) => {
  const params = {};
  if (mes) params.mes = mes;
  if (ano) params.ano = ano;
  if (receitaMensal) params.receitaMensal = receitaMensal;
  
  const response = await api.get('dashboard/lucro-presumido', { params });
  return response;
};

export default {
  getMetricas,
  getFluxoMensal,
  getDespesasPorCategoria,
  calcularLucroPresumido
};
